<template>
    <label class="file-select">
        <div class="btn" :class="btnClass">
            <span v-if="value">Plik: {{value.name}}</span>
            <span v-else>Wybierz plik</span>
        </div>
        <input type="file" :accept="accept ? accept : '*'"  @change="handleFileChange" />
    </label>
</template>

<script>
    export default {
        name: 'SsFile',
        props: {
            value: File,
            accept: {
                type: String,
                default: ''
            }
        },

        computed: {
          btnClass(){
              return this.value ? 'btn-success' : 'btn-primary';
          }
        },
        methods: {
            handleFileChange(e) {
                this.$emit('input', e.target.files[0])
            }
        },
    }
</script>

<style lang="scss" scoped>
    .file-select .btn{
        padding: 0.65rem 1rem;
        min-width: 150px;
        text-align: center;
        &.btn-success{
            width: 150px;
            white-space: nowrap;
            overflow: hidden;
            -ms-text-overflow: ellipsis;
            text-overflow: ellipsis;
        }
    }
    .file-select > input[type="file"] {
        display: none;
    }
</style>
